import React, { useEffect, useState, useRef, ChangeEvent } from "react";
import BackgroundWhatsapp from "../../../img/fondo_whatsapp.webp";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { ChatSelect } from "./ChatRoom";
import Spinner from "../../../components/helpers/Spinner";
import SendMediaMessage from "./SendMediaMessage";
import { useAppSelector } from "../../../hooks/hooks";

import { Swiper, SwiperSlide } from "swiper/react";

interface MediaFile {
    file: File;
    base64: string;
    name: string;
    caption: string;
}

export const MessageDetail = ({
    chatSelect,
    setChats30,
    setVista,
    selectedFiles,
    setSelectedFiles,
    nuevoMensaje,
    setNuevoMensaje,
    mensajes,
    setMensajes,
    fileSeleccionadoIndex,
    setFileSeleccionadoIndex,
    hotel,
}: {
    chatSelect: ChatSelect;
    setChats30: (chat: []) => void;
    setVista: React.Dispatch<React.SetStateAction<string>>;
    selectedFiles: MediaFile[];
    setSelectedFiles: React.Dispatch<React.SetStateAction<MediaFile[]>>;
    nuevoMensaje: string;
    setNuevoMensaje: React.Dispatch<React.SetStateAction<string>>;
    mensajes: any[];
    setMensajes: React.Dispatch<React.SetStateAction<any[]>>;
    fileSeleccionadoIndex: number | null;
    setFileSeleccionadoIndex: React.Dispatch<
        React.SetStateAction<number | null>
    >;
    hotel: boolean;
}) => {
    const [cargando, setCargando] = useState(false);
    const [cargandoMsj, setCargandoMsj] = useState(false);
    const corredor = useAppSelector((state) => state.corredor);
    const casa = useAppSelector((state) => state.landing_house.house);

    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const mensajesEndRef = useRef<HTMLDivElement>(null);
    const [primeraCarga, setPrimeraCarga] = useState(true);
    const mensajesContainerRef = useRef<HTMLDivElement>(null);
    const initialLoadRef = useRef(false);
    const prevHeightRef = useRef(0);
    const shouldAdjustScroll = useRef(false);

    const handleScrollUp = (e: React.UIEvent<HTMLDivElement>) => {
        if (!e.nativeEvent.isTrusted) return;
        // NO dejar pasar scroll up hasta que la primera carga haya terminado:
        if (!initialLoadRef.current) return;
        console.log(totalPages, "loading");
        const { scrollTop, scrollHeight } = e.currentTarget;

        if (scrollTop <= 100 && page < totalPages - 1 && !loading) {
            prevHeightRef.current = scrollHeight;
            shouldAdjustScroll.current = true;

            getChatMessages(page + 1);
        }
    };

    const getChatMessages = async (pageToLoad: number) => {
        console.log("getChatMessages", pageToLoad, loading);
        if (loading) {
            console.log("Ya se está cargando, retornando");
            return;
        }
        setLoading(true);
        /*  if (pageToLoad === 0 && mensajes.length > 0) {
            console.log("retornando");
            return;
        } */
        console.log("chat id select getChatMessage", chatSelect);
        try {
            const data = await fetchAxiosToken({
                url: `/pedidos/mensajes-chats-whatsapp/${pageToLoad}`,
                method: "post",
                body: {
                    chatId: chatSelect.chatId,
                    token_whatsapp: hotel
                        ? casa.token_whatsapp
                        : corredor.token_whatsapp,
                },
            });
            const {
                mensajes: newMensajes,
                page: newPage,
                totalPages: newTotal,
            } = data;
            console.log("newMensajes", newMensajes);
            setMensajes((prev) =>
                pageToLoad === 0 ? newMensajes : [...newMensajes, ...prev]
            );
            console.log("newTotal", newTotal);
            setPage(newPage);
            setTotalPages(newTotal);

            console.log("chatSelect", chatSelect);
            {
                chatSelect.unread > 0 &&
                    setTimeout(() => {
                        fetchAxiosToken({
                            url: `/pedidos/chat-visto-whatsapp`,
                            method: "post",
                            body: {
                                chatId: chatSelect.chatId,
                                unread: chatSelect.unread,
                                token_whatsapp: hotel
                                    ? casa.token_whatsapp
                                    : corredor.token_whatsapp,
                            },
                        });
                    }, 200);
            }
        } catch (error) {
            console.error("Error fetching chat messages:", error);
        } finally {
            setLoading(false);
            setCargando(false);
        }
    };

    const sendMessage = async () => {
        if (nuevoMensaje.trim() === "") return;

        setCargandoMsj(true);

        try {
            await fetchAxiosToken({
                url: `/pedidos/enviar-mensaje-whatsapp`,
                method: "post",
                body: {
                    chatId: chatSelect.chatId,
                    message: nuevoMensaje,
                    token_whatsapp: hotel
                        ? casa.token_whatsapp
                        : corredor.token_whatsapp,
                },
            });

            setMensajes((prevMensajes) => [
                ...prevMensajes,
                {
                    type: "text",
                    body: nuevoMensaje,
                    fromMe: true,
                    sentAt: new Date().toLocaleTimeString("es-ES", {
                        hour: "2-digit",
                        minute: "2-digit",
                    }),
                },
            ]);

            setNuevoMensaje("");
            scrollToBottom();
            setCargandoMsj(false);
        } catch (error) {
            setCargandoMsj(false);

            console.error("Error sending message:", error);
        }
    };

    useEffect(() => {
        chatSelect.chatId && getChatMessages(0);
    }, [chatSelect.chatId]);

    useEffect(() => {
        if (shouldAdjustScroll.current && mensajesContainerRef.current) {
            const newHeight = mensajesContainerRef.current.scrollHeight;
            mensajesContainerRef.current.scrollTop =
                newHeight - prevHeightRef.current;
            shouldAdjustScroll.current = false;
        }
    }, [mensajes]);

    const sendMediaMessages = async () => {
        if (!selectedFiles.length) {
            alert("Selecciona al menos un archivo.");
            return;
        }
        setCargandoMsj(true);
        try {
            const formData = new FormData();
            formData.append("chatId", chatSelect.chatId);
            formData.append(
                "token_whatsapp",
                hotel ? casa.token_whatsapp : corredor.token_whatsapp
            );
            selectedFiles.forEach((media) => {
                formData.append("media", media.file);
                formData.append("caption", media.caption);
            });
            await fetchAxiosToken({
                url: `/pedidos/enviar-mensaje-media-whatsapp`,
                method: "post",
                body: formData,
            });
            setSelectedFiles([]);
            scrollToBottom();

            setTimeout(getChatMessages, 3000);
        } catch (error) {
            console.error(error);
        } finally {
            setCargandoMsj(false);
        }
    };

    const scrollToBottom = () => {
        if (mensajesEndRef.current) {
            mensajesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        if (!cargando) {
            if (page === 0) {
                scrollToBottom();
            }
            setTimeout(() => {
                initialLoadRef.current = true;
            }, 10000);
        }
    }, [mensajes, cargando]);

    const openDocumentInNewTab = (data: string, mimetype: string) => {
        const byteCharacters = atob(data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimetype });

        const blobUrl = URL.createObjectURL(blob);
        const newWindow = window.open(blobUrl);
        if (newWindow) {
            newWindow.document.title = "Documento";
        }

        setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
        }, 1000 * 60);
    };

    const openMediaInNewTab = (data: string, mimetype: string) => {
        const newWindow = window.open();
        if (newWindow) {
            newWindow.document.write(
                `<img src="data:${mimetype};base64,${data}" style="width: 100vw; height: 100vh; object-fit: contain;" />`
            );
            newWindow.document.close();
        }
    };

    function formatWhatsAppText(text: string): React.ReactNode[] {
        const regex = /```([\s\S]*?)```|\*(.*?)\*|_(.*?)_|~(.*?)~/g;
        const nodes: React.ReactNode[] = [];
        let lastIndex = 0;
        let match: RegExpExecArray | null;

        while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
                nodes.push(text.slice(lastIndex, match.index));
            }

            if (match[1] != null) {
                nodes.push(
                    <code
                        key={nodes.length}
                        style={{
                            background: "#eee",
                            padding: "2px 4px",
                            borderRadius: 4,
                        }}>
                        {match[1]}
                    </code>
                );
            } else if (match[2] != null) {
                nodes.push(<strong key={nodes.length}>{match[2]}</strong>);
            } else if (match[3] != null) {
                nodes.push(<em key={nodes.length}>{match[3]}</em>);
            } else if (match[4] != null) {
                nodes.push(<s key={nodes.length}>{match[4]}</s>);
            }
            lastIndex = regex.lastIndex;
        }

        if (lastIndex < text.length) {
            nodes.push(text.slice(lastIndex));
        }

        return nodes;
    }

    const renderMessageContentBase64 = (message: any) => {
        if (message.hasMedia && message.media) {
            const {
                mimetype,
                data,
                filename,
                pageCount,
                caption,
                animated,
                base64,
            } = message.media;

            if (mimetype.startsWith("image/")) {
                return (
                    <div className="relative">
                        <img
                            src={`data:${mimetype};base64,${base64}`}
                            alt="Imagen enviada"
                            className="object-cover w-40 h-40 rounded"
                        />
                        <button
                            className="absolute top-0 right-0 p-1 text-white bg-black rounded"
                            onClick={() => openMediaInNewTab(base64, mimetype)}>
                            <svg
                                className="w-6 h-6 text-white"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round">
                                {" "}
                                <path stroke="none" d="M0 0h24v24H0z" />{" "}
                                <path d="M4 8v-2a2 2 0 0 1 2 -2h2" />{" "}
                                <path d="M4 16v2a2 2 0 0 0 2 2h2" />{" "}
                                <path d="M16 4h2a2 2 0 0 1 2 2v2" />{" "}
                                <path d="M16 20h2a2 2 0 0 0 2 -2v-2" />
                            </svg>
                        </button>
                    </div>
                );
            }

            if (mimetype.startsWith("video/")) {
                return (
                    <div className="relative">
                        <video controls className="w-40 h-40 rounded">
                            <source
                                src={`data:${mimetype};base64,${base64}`}
                                type={mimetype}
                            />
                            Tu navegador no soporta el formato de video.
                        </video>
                    </div>
                );
            }

            if (
                message.type.startsWith("audio/") ||
                message.type === "voice" ||
                message.type === "audio"
            ) {
                return (
                    <div className="flex flex-col w-36">
                        <audio controls className="w-full">
                            <source
                                src={`data:${mimetype};base64,${base64}`}
                                type={mimetype}
                            />
                            Tu navegador no soporta el formato de audio.
                        </audio>
                    </div>
                );
            }

            if (message.type === "sticker") {
                return (
                    <div className="relative">
                        <img
                            src={`data:${mimetype};base64,${base64}`}
                            alt="Sticker"
                            className={`w-32 h-32 ${
                                animated ? "animate-pulse" : ""
                            }`}
                        />
                    </div>
                );
            }

            if (
                message.type === "document" ||
                mimetype.startsWith("application/")
            ) {
                return (
                    <div className="flex flex-col items-start space-y-1">
                        <button
                            className="text-blue-500 underline"
                            onClick={() =>
                                openDocumentInNewTab(base64, mimetype)
                            }>
                            Archivo {mimetype.split("/")[1]} / Abrir{" "}
                        </button>
                        {pageCount != null && (
                            <span className="text-xs text-gray-500">
                                {pageCount} página{pageCount > 1 && "s"}
                            </span>
                        )}
                    </div>
                );
            }

            return (
                <span className="w-auto text-sm text-red-500">
                    Medio no soportado ({mimetype})
                </span>
            );
        }

        if (message.type === "text") {
            return <span className="w-auto text-sm">{message.body}</span>;
        }

        return (
            <span className="w-auto text-sm">Tipo de mensaje no soportado</span>
        );
    };

    const openUrl = (url: string) => {
        window.open(url, "_blank");
    };

    const renderMessageContent = (message: any) => {
        if (message.type === "link_preview" && message.media?.data) {
            return (
                <a
                    href={message.media.data}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 underline">
                    {message.media.data}
                </a>
            );
        }

        if (message.media && message.media.status) {
            return <span className="text-sm">{message.media.status}</span>;
        }

        if (message.media && message.media.base64) {
            return renderMessageContentBase64(message);
        }

        if (message.hasMedia && message.media && message.media.data) {
            const {
                mimetype,
                data,
                filename,
                pageCount,
                caption,
                base64,
                animated,
            } = message.media;

            if (mimetype.startsWith("image/")) {
                return (
                    <div className="relative">
                        <img
                            src={data}
                            alt={caption || "Imagen"}
                            className="object-cover w-40 h-40 rounded"
                        />
                        <button
                            className="absolute top-0 right-0 p-1 text-white bg-black rounded"
                            onClick={() => openUrl(data)}>
                            {/* fullscreen icon */}
                            <svg
                                className="w-6 h-6"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round">
                                <path d="M4 8V4h4" />
                                <path d="M16 4h4v4" />
                                <path d="M20 16v4h-4" />
                                <path d="M8 20H4v-4" />
                            </svg>
                        </button>
                    </div>
                );
            }
            if (mimetype.startsWith("video/")) {
                return (
                    <div className="relative">
                        <video
                            controls
                            className="w-40 h-40 rounded"
                            src={data}>
                            Tu navegador no soporta el formato de video.
                        </video>
                    </div>
                    // <video controls className="w-40 h-40 rounded" src={data} />
                );
            }
            // voice messages as audio
            if (
                (message.type === "voice" || mimetype.startsWith("audio/")) &&
                data
            ) {
                return (
                    <div className="flex flex-col w-36">
                        <audio controls className="w-full">
                            <source src={data} type={mimetype} />
                            Tu navegador no soporta el formato de audio.
                        </audio>
                    </div>
                );
            }
            if (mimetype === "audio/ogg; codecs=opus" && base64) {
                return (
                    <div className="flex flex-col w-36">
                        <audio controls className="w-full">
                            <source
                                src={`data:${mimetype};base64,${base64}`}
                                type={mimetype}
                            />
                            Tu navegador no soporta el formato de audio.
                        </audio>
                    </div>
                );
            }
            if (
                message.type === "document" ||
                mimetype.startsWith("application/")
            ) {
                return (
                    <div className="flex flex-col items-start space-y-1">
                        <button
                            className="text-blue-600 underline"
                            onClick={() => openUrl(data)}>
                            {filename || "Abrir archivo"}
                        </button>
                        {pageCount != null && (
                            <span className="text-xs text-gray-500">
                                {pageCount} página{pageCount > 1 ? "s" : ""}
                            </span>
                        )}
                    </div>
                );
            }

            return (
                <span className="text-sm text-red-500">Media no soportado</span>
            );
        }

        if (message.type === "text") {
            return (
                <div style={{ whiteSpace: "pre-wrap" }} className="text-sm">
                    {formatWhatsAppText(message.body)}
                </div>
            );
        }

        return <span className="text-sm">Tipo no soportado</span>;
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;
        const total = selectedFiles.length + files.length;
        if (total > 50) {
            alert("Máximo 50 archivos.");
            return;
        }
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64 = (reader.result as string).split(",")[1];
                setSelectedFiles((prev) => [
                    ...prev,
                    { file, base64, name: file.name, caption: "" },
                ]);
            };
            reader.readAsDataURL(file);
        });
        e.target.value = "";
        setFileSeleccionadoIndex(0);
    };

    const handleOutFiles = () => {
        setSelectedFiles([]);
        scrollToBottom();
    };

    const removeFile = (idxToRemove: number) => {
        setSelectedFiles((prev) => {
            const updated = [...prev];
            updated.splice(idxToRemove, 1);

            // 👇 Actualizar fileSeleccionadoIndex si el que se borra está siendo visualizado
            setFileSeleccionadoIndex((currentIndex) => {
                if (currentIndex === null) return null;

                if (idxToRemove === currentIndex) {
                    // Si es el primero, pasar al siguiente si existe
                    if (idxToRemove === 0 && updated.length > 0) return 0;

                    // Si hay uno anterior
                    if (idxToRemove > 0) return currentIndex - 1;

                    // No hay más archivos
                    return null;
                } else if (idxToRemove < currentIndex) {
                    // Si se elimina uno antes del seleccionado, reajusta índice
                    return currentIndex - 1;
                }

                return currentIndex;
            });

            return updated;
        });
    };

    return (
        <div className="">
            <div
                className={`${
                    selectedFiles.length === 0
                        ? "opacity-100"
                        : " opacity-0 hidden "
                } pt-2 md:pt-0`}>
                <div className="flex items-center justify-between w-full gap-2 p-1 bg-slate-100">
                    <div className="flex items-center md:py-3 py-1.5 w-full">
                        <div className="flex items-center justify-between w-full">
                            <div className="flex items-center justify-center pb-2 border-b border-b-slate-100">
                                <div
                                    onClick={() => setVista("chats")}
                                    className="flex mx-2 cursor-pointer md:hidden hover:scale-105">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke-width="1.5"
                                        stroke="currentColor"
                                        className="w-5 h-5">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M15.75 19.5 8.25 12l7.5-7.5"
                                        />
                                    </svg>
                                </div>
                                <p className="ml-3 text-sm font-medium md:text-lg text-slate-600">
                                    {chatSelect.name}
                                </p>
                            </div>
                            <div
                                onClick={() => setVista("config")}
                                className="flex items-center justify-end w-full p-2 cursor-pointer md:hidden">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className=" md:h-10 md:w-10 w-6 h-6 text-[#029BFC] ">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        backgroundImage: `url(${BackgroundWhatsapp})`,
                        backgroundRepeat: "no-repeat",
                    }}
                    className="w-full h-[70.5vh] md:h-[59vh]">
                    <div
                        ref={mensajesContainerRef}
                        onScroll={handleScrollUp}
                        className="overflow-auto h-[99%] py-2 px-4">
                        {cargando ? (
                            <div>{<Spinner />}</div>
                        ) : (
                            mensajes.map((mensaje: any, i) => (
                                <div
                                    key={mensaje.id}
                                    className={`flex flex-col ${
                                        mensaje.fromMe
                                            ? "justify-end items-end"
                                            : "justify-start items-start"
                                    } gap-3`}>
                                    <div
                                        className={`relative min-w-[80px]  pt-1 px-2 pb-4 my-2 inline-block bg-[#029BFC] rounded-lg text-white break-all ${
                                            mensaje.fromMe
                                                ? "bg-[#029BFC] text-white"
                                                : "bg-gray-400 text-white"
                                        }`}>
                                        {mensaje.media &&
                                            mensaje.media.body && (
                                                <div
                                                    className="text-xs"
                                                    style={{
                                                        whiteSpace: "pre-wrap",
                                                    }}>
                                                    {formatWhatsAppText(
                                                        mensaje.media.body
                                                    )}
                                                </div>
                                            )}
                                        {renderMessageContent(mensaje)}
                                        {mensaje.media &&
                                            mensaje.media.caption && (
                                                <div
                                                    className="text-xs max-w-[144px]"
                                                    style={{
                                                        whiteSpace: "pre-wrap",
                                                    }}>
                                                    {formatWhatsAppText(
                                                        mensaje.media.caption
                                                    )}
                                                </div>
                                            )}
                                        <span className="absolute bottom-0 text-xs right-2">
                                            {mensaje.sentAt}
                                        </span>
                                    </div>
                                </div>
                            ))
                        )}

                        <div ref={mensajesEndRef} />
                    </div>
                </div>
                {chatSelect.chatId && (
                    <div className="flex items-start justify-between w-full gap-2 p-2 md:mb-10 bg-slate-100">
                        <div className="flex items-start justify-start py-2 bg-slate-100">
                            <SendMediaMessage
                                selectedFiles={selectedFiles}
                                setSelectedFiles={setSelectedFiles}
                                setFileSeleccionadoIndex={
                                    setFileSeleccionadoIndex
                                }
                            />
                        </div>
                        {selectedFiles.length === 0 && (
                            <input
                                type="text"
                                value={nuevoMensaje}
                                onChange={(e) =>
                                    setNuevoMensaje(e.target.value)
                                }
                                placeholder="Escribe un mensaje..."
                                className="w-full p-1 mt-2 bg-white rounded-lg h-9"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") sendMessage();
                                }}
                            />
                        )}
                        <div
                            className="mx-2 mt-2"
                            onClick={
                                selectedFiles.length === 0
                                    ? sendMessage
                                    : sendMediaMessages
                            }>
                            {" "}
                            {cargandoMsj ? (
                                <Spinner width={8} />
                            ) : (
                                <svg
                                    className="w-8 h-8 text-blue-500 cursor-pointer hover:scale-105"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round">
                                    <line x1="22" y1="2" x2="11" y2="13" />
                                    <polygon points="22 2 15 22 11 13 2 9 22 2" />
                                </svg>
                            )}
                        </div>
                    </div>
                )}
            </div>

            <div
                className={` ${
                    selectedFiles.length === 0
                        ? "opacity-0 hidden"
                        : "opacity-100"
                } relative flex flex-col justify-center items-center w-full`}>
                <div
                    onClick={() => handleOutFiles()}
                    className="absolute top-10 left-10">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-8 h-8 cursor-pointer hover:scale-105">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18 18 6M6 6l12 12"
                        />
                    </svg>
                </div>
                {fileSeleccionadoIndex !== null &&
                    selectedFiles[fileSeleccionadoIndex] && (
                        <div className="relative flex flex-col items-center justify-center w-full md:mt-10 md:mb-4 ">
                            <div className="relative 2xl:w-[400px] 2xl:h-[400px] md:h-[300px] md:w-[300px] h-[200px] w-[200px] rounded-lg overflow-hidden shadow-lg bg-gray-100">
                                {/* Botón cerrar */}

                                {(() => {
                                    const file =
                                        selectedFiles[fileSeleccionadoIndex];
                                    if (!file) return null;

                                    if (file.file.type.startsWith("image/")) {
                                        return (
                                            <img
                                                src={`data:${file.file.type};base64,${file.base64}`}
                                                alt={file.name}
                                                className="object-cover w-full h-full"
                                            />
                                        );
                                    } else if (
                                        file.file.type.startsWith("video/")
                                    ) {
                                        return (
                                            <video
                                                controls
                                                className="object-cover w-full h-full">
                                                <source
                                                    src={`data:${file.file.type};base64,${file.base64}`}
                                                    type={file.file.type}
                                                />
                                            </video>
                                        );
                                    } else if (
                                        file.file.type.startsWith("audio/")
                                    ) {
                                        return (
                                            <div className="flex items-center justify-center h-full p-4">
                                                <audio
                                                    controls
                                                    className="w-full">
                                                    <source
                                                        src={`data:${file.file.type};base64,${file.base64}`}
                                                        type={file.file.type}
                                                    />
                                                </audio>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div className="p-4 text-sm text-center">
                                                <p className="font-semibold">
                                                    Archivo:
                                                </p>
                                                <p className="break-words">
                                                    {file.name}
                                                </p>
                                            </div>
                                        );
                                    }
                                })()}
                            </div>

                            <div className="w-5/6 mx-auto mt-5">
                                <textarea
                                    value={
                                        selectedFiles[fileSeleccionadoIndex]
                                            .caption
                                    }
                                    onChange={(e) => {
                                        const newCaption = e.target.value;
                                        if (newCaption.length <= 500) {
                                            const updatedFiles = [
                                                ...selectedFiles,
                                            ];
                                            updatedFiles[
                                                fileSeleccionadoIndex
                                            ] = {
                                                ...updatedFiles[
                                                    fileSeleccionadoIndex
                                                ],
                                                caption: newCaption,
                                            };
                                            setSelectedFiles(updatedFiles);
                                        }
                                    }}
                                    className="w-full p-2 border rounded-lg resize-none"
                                    rows={3}
                                    placeholder="Escribe tu mensaje..."
                                />
                                <div className="mt-1 text-sm text-right text-gray-600">
                                    {
                                        selectedFiles[fileSeleccionadoIndex]
                                            .caption.length
                                    }
                                    /500
                                </div>
                            </div>
                        </div>
                    )}
                <div className="flex items-center justify-center w-full gap-2 px-4 mx-auto mt-5 scroll-x ">
                    <div className="flex max-w-full gap-2 overflow-x-auto">
                        {selectedFiles.map((media, idx) => (
                            <div
                                onClick={() => setFileSeleccionadoIndex(idx)}
                                className="relative cursor-pointer min-w-[80px] w-20 h-20 rounded-lg border overflow-hidden flex justify-center items-center bg-gray-100 shadow-md group">
                                {media.file.type.startsWith("image/") && (
                                    <img
                                        src={`data:${media.file.type};base64,${media.base64}`}
                                        alt={media.name}
                                        className="object-cover w-full h-full"
                                    />
                                )}

                                {media.file.type.startsWith("video/") && (
                                    <video
                                        controls
                                        className="object-cover w-full h-full">
                                        <source
                                            src={`data:${media.file.type};base64,${media.base64}`}
                                            type={media.file.type}
                                        />
                                    </video>
                                )}

                                {media.file.type.startsWith("audio/") && (
                                    <div className="w-full p-1 text-xs text-center">
                                        <audio controls className="w-full">
                                            <source
                                                src={`data:${media.file.type};base64,${media.base64}`}
                                                type={media.file.type}
                                            />
                                        </audio>
                                    </div>
                                )}

                                {!["image/", "video/", "audio/"].some((t) =>
                                    media.file.type.startsWith(t)
                                ) && (
                                    <div className="px-1 text-xs text-center">
                                        <p className="truncate">Archivo:</p>
                                        <p className="truncate">{media.name}</p>
                                    </div>
                                )}

                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        removeFile(idx);
                                    }}
                                    className="absolute top-0 right-0 items-center justify-center hidden w-5 h-5 text-xs text-white bg-red-500 rounded-full group-hover:flex">
                                    ×
                                </button>
                            </div>
                        ))}
                    </div>

                    <label className="relative flex items-center justify-center flex-shrink-0 w-20 h-20 overflow-hidden bg-gray-100 border rounded-lg shadow-md">
                        <input
                            type="file"
                            multiple
                            accept="image/*,video/*,audio/*,.pdf"
                            className="w-full h-full opacity-0"
                            onChange={handleFileChange}
                            maxLength={50}
                        />
                        <div className="absolute inset-0 flex items-center justify-center transition duration-200 bg-gray-200 bg-opacity-50 hover:bg-opacity-75">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className="w-10 h-10 text-gray-500 cursor-pointer hover:scale-105">
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M12 4.5v15m7.5-7.5h-15"
                                />
                            </svg>
                        </div>
                    </label>
                    <div
                        onClick={() => sendMediaMessages()}
                        className="flex items-center justify-center flex-shrink-0 w-16 h-16 text-white bg-green-500 rounded-full cursor-pointer hover:scale-105">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            className="w-6 h-6 text-white ">
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
};
